export const monochromeWall = `\
-- monochrome running bond
-- running bond with grayscale filter

@filter grayscale(100%)

S >>
S
`
